import CollectionModal from "./collection-modal";
import FavoritesManager from "../utils/favorites-manager";
import CollectionManager from "../utils/collection-manager";

export class LikeLabel {
    constructor($label) {
        this.$label = $label;

        this.triggerClick = this.triggerClick.bind(this);
        this.$label.addEventListener('click', this.triggerClick);
    }

    triggerClick(e) {
        if (e.target.closest('[data-like]')) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        const evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });

        this.$label.parentNode.querySelector('[data-like]').dispatchEvent(evt);
    }
}

export class LikeToggle {
    constructor($toggle) {
        this.$toggle = $toggle;
        this.$label = $toggle.parentNode.querySelector('[data-like-label]');
        this.objectType = $toggle.dataset.objectType;
        this.objectId = $toggle.dataset.objectId;
        this.showCollectionModal = $toggle.dataset.showCollectionModal;
        this.currentState = this.isLiked();

        if (this.showCollectionModal) {
            this.initCollectionModal();
        }

        this.toggle = this.toggle.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.$toggle.addEventListener('click', this.toggle);
        document.addEventListener('favorites:state-changed', this.handleStateChange);
        document.addEventListener('collection:state-changed', this.handleStateChange);
    }

    /**
     * Init collection modal
     */
    initCollectionModal(){
        this.$collectionModal = this.$toggle.parentNode.parentNode.querySelector('[data-collection-modal]');

        if (this.showCollectionModal && ! this.$collectionModal) {
            console.error('No element found with data-collection-modal for like toggle with type ' + this.objectType + ' and object id' + this.objectId);
        }

        this.collectionModal = (new CollectionModal(this.$toggle, this.$collectionModal, this.objectType, this.objectId));
    }

    async toggle(e) {
        e.preventDefault();

        if (this.showCollectionModal) {
            this.collectionModal.openModal();
            if (this.isLiked()) {
                // if the item is liked and we need to show the collection modal
                // we stop here the dislike is now done via the collection modal
                this.collectionModal.setIsLiked(true);
            }
            // We stop here and just open the collection modal
            return;
        }
        this.toggleLikeState(this.$toggle, !this.isLiked());
        const result = await FavoritesManager.togglePublication(this.objectType, this.objectId);

        if (this.collectionModal) {
            this.collectionModal.setIsLiked(result.state);
        }
    }

    /**
     * Sync all toggles for the current publication.
     *
     * @param {{detail: {publicationType: string, publicationId: string, state: boolean}}} event
     */
    async handleStateChange(event) {
        const detail = event.detail;
        const isCurrentPublication = String(detail.publicationType) === String(this.objectType)
            && String(detail.publicationId) === String(this.objectId);

        if (!isCurrentPublication) {
            return;
        }

        const isFavorited = await FavoritesManager.isFavorited(this.objectType, this.objectId);
        const inCollection = this.showCollectionModal
            ? await CollectionManager.isPublicationInAnyCollection(this.objectType, this.objectId)
            : false ;

        document
            .querySelectorAll('[data-toggle-like][data-object-type="' + this.objectType + '"][data-object-id="' + this.objectId + '"]')
            .forEach(($toggle) => {

                this.toggleLikeState($toggle, isFavorited, inCollection)
            });

        if (this.collectionModal) {
            this.collectionModal.setIsLiked(isFavorited);
        }
    }

    toggleLikeState($toggle, isFavorited, inCollection = false) {
        const favoriteActiveIcon = $toggle.querySelector('[data-like-active]');
        const collectionActiveIcon = $toggle.querySelector('[data-collection-active]');
        const favoriteIcon = $toggle.querySelector('[data-like-in-active]');

        if (favoriteActiveIcon) {
            favoriteActiveIcon.classList.toggle('d-none', !isFavorited );
        }

        if (collectionActiveIcon) {
            collectionActiveIcon.classList.toggle('d-none', isFavorited || !inCollection);
        }

        if (favoriteIcon) {
            favoriteIcon.classList.toggle('d-none', isFavorited || inCollection);
        }
    }

    /**
     *
     * Is liked
     *
     * @return {boolean}
     */
    isLiked() {
        return ! this.$toggle.querySelector('[data-like-active]').classList.contains('d-none');
    }
}
